<div class="registry" *cmLet="(filters$ | async) as filters">
    <header class="registry__header header" [ngClass]="{ 'registry__header-active-filters': filtersFilled }">
        <div class="header__section">
            <div *ngIf="organization?.logo" class="logo-container">
                <img class="header__logo" [src]="organization?.logo" alt="Company logo" />
            </div>
            <div class="header__logo-default" *ngIf="!organization?.logo">
                <cm-icon name="company-logo-placeholder" class="placeholder-img"></cm-icon>
            </div>
            <div class="header__organization-info">
                <h2 class="prof-header prof-header--level-4">{{ organization.name }}</h2>
                <p class="header__subtitle">The registry</p>
            </div>
        </div>
        <div class="header__filters">
            <div class="header__filters-search">
                <cm-search-input
                    class="header__search"
                    [value]="filters.search"
                    (valueDebouncedChange)="onSearchChange($event)"
                    [minSearchLength]="2"
                ></cm-search-input>
                <i
                    *ngIf="isDesktop"
                    class="fa fa-question-circle"
                    container="body"
                    ngbTooltip="You may search for an individual’s first name, last name, or first and last name."
                ></i>
            </div>
            <div class="registry-filters__block registry-filters" *ngIf="isDesktop">
                <div class="registry-filters mr-2" *ngIf="showBoards">
                    <span>{{ boardLabel }}:</span>
                    <cm-select
                        class="registry-control"
                        [ngModel]="selectedBoard"
                        (ngModelChange)="selectFilter('organizationId', $event)"
                        [options]="boardList"
                    ></cm-select>
                </div>
                <div class="registry-filters" *ngIf="!showBoards">
                    <span>Credential:</span>
                    <cm-typeahead
                        class="registry-control"
                        [formatter]="credentialFormatter"
                        [request$]="onCredentialSearch"
                        [disabled]="showBoards && !selectedBoard"
                        [ngModel]="selectedCredentialOption"
                        (ngModelChange)="selectFilter('credential', $event)"
                        placeholder="Select"
                    >
                    </cm-typeahead>
                </div>
                <button class="btn btn-default reset-filters-button" type="button" (click)="resetFilters()">
                    RESET FILTER
                </button>
            </div>
            <cm-filter-button *ngIf="!isDesktop" (click)="openSideBar(smartFilters)"></cm-filter-button>
            <ng-template #smartFilters>
                <cm-sidebar-filters
                    (closeSideBar)="closeSideBar()"
                    (resetFilters)="onResetFilters()"
                    filtersTitle="Filters"
                    [count]="count"
                >
                    <cm-smart-filters></cm-smart-filters>
                </cm-sidebar-filters>
            </ng-template>
        </div>
        <cm-active-filters *ngIf="!isDesktop" class="active-filters-wrapper"></cm-active-filters>
    </header>
    <cm-message-block type="info" [showIcon]="false" class="message-block" *ngIf="filtersFilled && registries.length">
        NOTE: Please note that the results below may include prior versions of the selected credential, and the
        credential names for prior versions may have been slightly different.
    </cm-message-block>
    <div class="registry__filters-bar">
        <cm-alphabet-filter
            class="alphabet-filter"
            [letter]="selectedLetter"
            (selectLetter)="onSelectedLetter($event)"
        ></cm-alphabet-filter>
        <p class="displayed-hint">{{ displayedCount }}</p>
    </div>
    <p class="displayed-hint">{{ displayedCount }}</p>
    <cm-registry-table
        *ngIf="isDesktop"
        class="registry__table-wrapper"
        [registries]="registries"
        [order]="order"
        [publicView]="true"
        (viewDetails)="onViewDetails($event)"
        (orderChange)="onOrderChange($event)"
    >
    </cm-registry-table>
    <div *ngIf="!isDesktop" class="registry__block">
        <cm-public-block-element
            *ngFor="let registry of registries"
            [entry]="registry"
            (viewDetailsClick)="onViewDetails($event)"
        >
        </cm-public-block-element>
        <cm-no-content
            *ngIf="!registries || !registries.length"
            class="no-content"
            [config]="noContentConfig"
        ></cm-no-content>
    </div>

    <footer class="registry__footer" *ngIf="count > filters.page_size">
        <ngb-pagination
            class="custom-pagination"
            [collectionSize]="count"
            [maxSize]="5"
            [pageSize]="filters.page_size"
            [page]="filters.page"
            (pageChange)="onPageChange($event)"
        ></ngb-pagination>
    </footer>
</div>
